import type { RescheduleContextDto } from '@shared/core/reschedule'
import ms from 'ms'
import { useQuery, UseQueryOptions } from 'react-query'
import { useHandleRetry } from 'src/modules/core/hooks/use-handle-retry'
import { RescheduleService } from 'src/services/reschedule.service'

export const GET_RESCHEDULE_PAGE_CONTEXT_CACHE_KEY = 'reschedule-page-context'

/** Only the reschedule page sends `view: 'reschedule'`: the server records a blocked open for it alone. */
export function useReschedulePageContext(urlCode: string, options?: UseQueryOptions<RescheduleContextDto>) {
  const handleRetry = useHandleRetry()
  return useQuery(
    [GET_RESCHEDULE_PAGE_CONTEXT_CACHE_KEY, urlCode],
    () => RescheduleService.getContext(urlCode, { view: 'reschedule' }),
    {
      enabled: !!urlCode,
      staleTime: ms('5 minutes'),
      retry: handleRetry,
      ...options,
    },
  )
}
